var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal", class: { active: _vm.active } }, [
    _c("div", { staticClass: "modal-background" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-content" },
      [
        _vm.videoURL
          ? _c("iframe-loader", {
              attrs: { url: _vm.videoURL, alwaysShow: "" }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("a", {
      staticClass: "modal-close",
      attrs: { href: "" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.closeModal()
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }